import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Box, CircularProgress } from '@mui/material';
import StoreContext from '../../react-core-lib/components/app/store-context';
import DisplayHandout from '../../components/authenticated/handout/display-handout';
import useFetchHandoutData from './use-fetch-handout-data';
import ErrorMessage from './error-message';

const HandoutContent = observer(({ linkId, clinicData, show3DModel, showMainIllustration, showTutorialVideo }) => {
    const { contentStore, imageStore } = useContext(StoreContext);
    const error = useFetchHandoutData(contentStore, imageStore, linkId);
    console.warn('clinic details! ', clinicData);
    // Adjusted check to include data availability
    const isLoading = !contentStore.isInitialized || !contentStore.handoutData || contentStore.handoutData.length === 0;

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <ErrorMessage
                message={`We were unable to load the handout. Please contact your ${process.env.REACT_APP_CETRA_CLINIC_TYPE === 'vet' ? 'veterinarian' : 'physiotherapist'}.`}
            />
        );
    }

    // Render DisplayHandout only when data is available
    return (
        <Container maxWidth="md" sx={{ width: '100%', overflowY: 'auto', backgroundColor: 'white' }}>
            {contentStore.handoutData.map((handout, index) =>
                handout ? (
                    <Box key={index} sx={{ my: 2 }}>
                        <DisplayHandout
                            handoutData={handout}
                            clinicData={clinicData}
                            show3DModel={show3DModel}
                            showMainIllustration={showMainIllustration}
                            showTutorialVideo={showTutorialVideo}
                        />
                    </Box>
                ) : null,
            )}
        </Container>
    );
});

export default HandoutContent;
